import { ImageClustersData } from "@radarly/models/insights";
import { SearchParams } from "@radarly/models/search";

export interface InsightsRepository {
  getImageClusters(
    projectId: number,
    query: SearchParams
  ): Promise<ImageClustersData>;
}

export const InsightsRepositoryUID = Symbol("Radarly/InsightsRepository");
